import styled from 'styled-components';

import { Text } from '../../../cdl/Text/Text';
import { translate } from '../../helpers/translate.helper';
import { Characters } from '../../helpers/unicode.helper';
import { useGroupContext } from '../../hooks/useGroupContext';
import { IconSelector } from '../../icons/cdl/Selector';
import { Box } from '../../ui/Box';
import { theme } from '../../ui/theme';

import { SidebarMenuChevronWrapper, SidebarMenuHeaderContainer } from './SidebarMenuHeader';

const SuperAdminContainer = styled(Box)`
    background: linear-gradient(225deg, #6a11cb 0%, #0001fe 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    display: flex;
    align-items: center;
    gap: ${theme.space[4]};
`;

export const SuperAdminSidebarMenuHeader = () => {
    const { name: groupContextName } = useGroupContext();

    return (
        <SidebarMenuHeaderContainer>
            <Box display="flex" flexDirection="column" alignItems="flex-start" gap={4} overflow="hidden">
                <SuperAdminContainer>
                    <Text variant={groupContextName ? 'extraSmall' : 'small'}>
                        {Characters.BLACK_FOUR_POINTED_STAR}
                    </Text>
                    <Text variant={groupContextName ? 'extraSmall' : 'small'} fontWeight="bold" fontStyle="italic">
                        {translate('global.superAdmin')}
                    </Text>
                </SuperAdminContainer>
                {groupContextName ? (
                    <Text
                        variant="extraSmall"
                        textAlign="left"
                        color="foreground.muted"
                        style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '100%',
                        }}
                    >
                        {groupContextName}
                    </Text>
                ) : null}
            </Box>
            <SidebarMenuChevronWrapper>
                <IconSelector width={16} height={16} />
            </SidebarMenuChevronWrapper>
        </SidebarMenuHeaderContainer>
    );
};
